import { useEffect, useRef, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import debounce from 'lodash/debounce';
import gql from 'graphql-tag';

const GET_SUGGESTIONS = gql`
  query searchSuggestions($query: String!) {
    searchSuggestions(query: $query)
  }
`;

const FetchSuggestions = props => {
  const mounted = useRef(false);
  const client = useApolloClient();
  const [state, setstate] = useState({
    loading: false,
    error: null,
    suggestions: [],
  });

  const reset = () => {
    setstate({
      loading: false,
      error: null,
      suggestions: [],
    });
  };

  const setSearchTerm = debounce(searchTerm => {
    if (searchTerm === '') {
      reset();
      return;
    }

    setstate({ ...state, loading: true });

    client
      .query({ query: GET_SUGGESTIONS, variables: { query: searchTerm } })
      .then(({ data: { searchSuggestions: suggestions } }) => {
        if (mounted.current) {
          props.onLoaded();
          setstate({ ...state, loading: false, suggestions });
        }
      })
      .catch(() => {
        if (mounted.current) {
          props.onLoaded();
          setstate({ ...state, loading: false, error: 'ERROOOR' });
        }
      });
  }, 500);

  const fetch = () => {
    if (mounted.current) {
      setSearchTerm(props.searchValue);
    }
  };

  function prepareFetch() {
    reset();
  }

  useEffect(() => {
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    prepareFetch();
    fetch();
  }, [props.searchValue]);

  return props.render(state);
};

export default FetchSuggestions;
